import type { MouseEventProps, UIComponent } from "@gik/core/types/UI";
import { useBemCN } from "@gik/core/utils/bemBlock";
import type React from "react";
import type { Color } from "react-color";
import type { GradientValue } from "../ColorPicker/GradientPicker";
import { parseColorsToGradientValues } from "../ColorPicker/GradientPicker";
import type { UISize } from "../typesValues";

export type ColorSwatchProps = {
	color?: Color;
	gradient?: GradientValue[];
	size?: UISize;
	circle?: boolean;
	active?: boolean;
} & UIComponent &
	MouseEventProps;

export function ColorSwatch({
	children,
	className,
	circle,
	active,
	size,
	color,
	gradient,
	...otherProps
}: React.PropsWithChildren<ColorSwatchProps>): React.ReactElement {
	const bem = useBemCN("color-swatch");

	const _gradient = gradient ? parseColorsToGradientValues(gradient) : null;

	return (
		<div
			{...bem(null, [
				{ circle },
				{ active },
				{ [`size-${size}`]: size },
				{ [className]: className },
			])}
			style={{
				// @ts-ignore
				["--color"]: color,
				background: _gradient
					? `linear-gradient(135deg,${_gradient} )`
					: undefined,
			}}
			{...otherProps}
		>
			{children}
		</div>
	);
}
